
/******************
	* This these helper methods are used for adding a wrapping element around a target element (blue.util.wrap),
	* (the new wrapper can be an element you created with JS, or just an element tag string, like 'div')
	* OR, removing the wrapping element from a target element (blue.util.unwrap)
	* Usage Example:
		const myEl = document.querySelector('.myEl')
		------EX 1 (wrap)------
			blue.util.wrap(myEl, 'div') // myEl is now a child of a div
		------EX 2 (wrap)------
			const wrapper = blue.util.createElement('section', {class: 'myNew-section', id: 'section-5'})
			blue.util.wrap(myElm, wrapper) // myEl is now a child of a <section id="section-5" class="myNew-section">
		------EX 3 (unwrap)------
			blue.util.unwrap(myEl) // myEl, as well as any sibling elements, have now been removed from the parent element, and the parent element has been removed from the page.


******************/
import { util } from '~/core';

export function unwrap(el) {
	const wrapper = el.parentElement
	const parent = wrapper.parentElement
	while (wrapper.firstChild) {
		parent.insertBefore(wrapper.firstChild, wrapper)
	}
	parent.removeChild(wrapper);
}

export function wrap(el, wrapper) {
	wrapper = typeof wrapper == 'string' ? document.createElement(wrapper) : wrapper
	el.parentNode.insertBefore(wrapper, el)
	wrapper.appendChild(el)
	return
}

export default {wrap, unwrap}

util.wrap = wrap
util.unwrap = unwrap